export type WhiteboardEventHandler = () => void;
export class WhiteboardEventService {
	private eventHandlers: Record<string, WhiteboardEventHandler> = {};

	constructor() {
		this.eventHandlers = {};
	}

	dispose() {
		this.eventHandlers = {};
	}

	/**
	 * This is called in Whiteboards to register the any event callbacks.
	 * Confluence FE can then use any of these events to trigger the whiteboard events.
	 */
	registerEventHandler(event: string, handler: WhiteboardEventHandler): void {
		this.eventHandlers[event] = handler;
	}

	/**
	 * This is called in Whiteboards to unregister the any event callbacks.
	 */
	unregisterEventHandler(event: string): void {
		delete this.eventHandlers[event];
	}

	/**
	 * Check if an event has any handlers registered to it
	 * @param event
	 */
	hasEventHandler(event: string): boolean {
		return this.eventHandlers[event] !== undefined;
	}

	/**
	 * Trigger an event in Whiteboards.
	 */
	triggerEvent(event: string): void {
		if (this.eventHandlers[event]) {
			this.eventHandlers[event]();
		}
	}
}
